<template><svg xmlns="http://www.w3.org/2000/svg" width="144" height="144" viewBox="0 0 144 144">
    <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="#E4EBEE" stroke-width="2.4" d="M34.02 128.436h75.96"/>
        <path fill="#F5F7F9" stroke="#ADBDCA" stroke-width="2.4" d="M13.5 120.16h119.367M120.07 51.119L89.113 66.97v52.748l31.147-15.95a5 5 0 0 0 2.722-4.45v-46.42a2 2 0 0 0-2.912-1.78zM55.244 49.628l-31.148 15.95a5 5 0 0 0-2.72 4.45v46.419a2 2 0 0 0 2.91 1.78l30.958-15.852V49.628z"/>
        <path fill="#FFF" stroke="#ADBDCA" stroke-width="2.4" d="M55.066 49.628L88.934 66.97v52.748l-33.868-17.343z"/>
        <g stroke="#E4EBEE" stroke-width="2.5">
            <path d="M121.176 15.396h-7.194M117.835 11.799v7.194"/>
        </g>
        <g stroke="#E4EBEE" stroke-width="2.5">
            <path d="M134.464 83.219h-3.597M132.794 81.42v3.597"/>
        </g>
        <g stroke="#E4EBEE" stroke-width="2.5">
            <path d="M27.64 41.534h-6.295M24.717 38.387v6.295"/>
        </g>
        <g stroke="#ADBDCA" stroke-width="2.4" transform="translate(41 4.42)">
            <path fill="#F5F7F9" d="M10.38 55.108C4.134 49.374.207 41.072.207 31.836.206 14.534 13.986.508 30.985.508c16.998 0 30.778 14.026 30.778 31.328 0 9.236-3.927 17.538-10.174 23.272L30.985 76.08 10.38 55.108z"/>
            <ellipse cx="30.985" cy="29.677" fill="#FFF" rx="10.46" ry="10.647"/>
            <ellipse cx="30.985" cy="29.677" fill="#FFF" rx="17.399" ry="17.709"/>
        </g>
    </g>
</svg>
</template>